import { render } from "./OverlayStack.vue?vue&type=template&id=1725b736"
import script from "./OverlayStack.vue?vue&type=script&lang=js"
export * from "./OverlayStack.vue?vue&type=script&lang=js"

import "./OverlayStack.vue?vue&type=style&index=0&id=1725b736&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__